import React, {useContext, useState} from 'react';
import Button from "@amzn/meridian/button";
import {injectIntl} from "react-intl";
import Row from "@amzn/meridian/row";
import Modal, {ModalFooter} from "@amzn/meridian/modal";
import Column from "@amzn/meridian/column";
import Text from "@amzn/meridian/text";
import Select, {SelectOption} from "@amzn/meridian/select";
import escapeRegExp from "lodash/escapeRegExp"
import Icon from "@amzn/meridian/icon";
import trashTokens from "@amzn/meridian-tokens/base/icon/trash";
import {DraftContext} from "../../../draftSave/context/DraftSaveContext";
import {CONFIG_TYPE, OPERATIONS} from "../../../util/Constants";
import {getTestConfigKey} from "../../../util/Util";
import {getLocalizedMessage} from "../../../util/Localization";

// getTestConfigKey sorts in place, so keys are taken off copies to leave the draft rows untouched.
const packageKey = (scannables) => getTestConfigKey([...scannables]);

const DeleteAslInductTestPackageModal = (props) => {

    const {intl, open, setOpen, mac} = props;
    const {getDraftData, deleteInstance, deleteAll} = useContext(DraftContext);
    const [selectedPackage, setSelectedPackage] = useState("")
    const [searchQuery, setSearchQuery] = useState("")

    const onCloseModal = () => {
        setOpen(false);
        setSelectedPackage("");
        setSearchQuery("");
    }

    // Rows already deleted in this draft are not offered again.
    const packageKeyList = getDraftData({stateKey: CONFIG_TYPE.ASL_INDUCT_TEST_PACKAGE, subKey: mac})
        .filter((value) => value.operation !== OPERATIONS.DELETE)
        .map(({scannables}) => packageKey(scannables));
    const searchRegExp = new RegExp(escapeRegExp(searchQuery), "i")
    const matchedKeys = packageKeyList.filter(option => !searchQuery || searchRegExp.test(option))

    const onClickConfirm = () => {
        if (selectedPackage) {
            deleteInstance({
                stateKey: CONFIG_TYPE.ASL_INDUCT_TEST_PACKAGE,
                subKey: mac,
                keyComparator: (instance) => packageKey(instance.scannables) === selectedPackage
            });
        }
        onCloseModal();
    }

    const onClickDeleteAll = () => {
        deleteAll({stateKey: CONFIG_TYPE.ASL_INDUCT_TEST_PACKAGE, subKey: mac});
        onCloseModal();
    }

    return (
        <Row>
            <Modal
                title={getLocalizedMessage({intl, stringId: "asltestpackage.deletetitle"})}
                open={open}
                onClose={onCloseModal}
                scrollContainer="viewport"
                closeLabel="Close"
                bodySpacingInset="medium">
                <Text tag="label" type="b200" color="primary">
                    {getLocalizedMessage({intl, stringId: "asltestpackage.deleteprompt"})}
                </Text>
                <Column spacing={"medium"} spacingInset={"medium"}>
                    <Select
                        value={selectedPackage}
                        onChange={setSelectedPackage}
                        searchQuery={searchQuery}
                        onSearch={setSearchQuery}
                        placeholder={getLocalizedMessage({intl, stringId: "sortertestconfig.delete"})}
                        width="100%">
                        {matchedKeys.map((key) =>
                            <SelectOption key={key} value={key} label={key}/>
                        )}
                        {!matchedKeys.length ? (
                            <Column alignmentVertical="center" spacing="100" spacingInset="100">
                                <Text alignment="center">
                                    {getLocalizedMessage({intl, stringId: packageKeyList.length
                                            ? "sortertestconfig.nomatch" : "sortertestconfig.notavailable"})}
                                </Text>
                            </Column>) : null}
                    </Select>
                </Column>
                <ModalFooter>
                    <Row alignmentHorizontal="justify" widths="fit">
                        <Button size="small" className="redBtn" onClick={onClickDeleteAll}>
                            <Icon tokens={trashTokens}/>
                            {getLocalizedMessage({intl, stringId: "modal.deleteAll"})}
                        </Button>
                        <Row alignmentHorizontal="right" widths="fit">
                            <Button type="secondary" size="small" onClick={onCloseModal}>
                                {getLocalizedMessage({intl, stringId: "modal.cancel"})}
                            </Button>
                            <Button type="primary" size="small" onClick={onClickConfirm} disabled={!selectedPackage}>
                                {getLocalizedMessage({intl, stringId: "modal.confirm"})}
                            </Button>
                        </Row>
                    </Row>
                </ModalFooter>
            </Modal>
        </Row>
    )
}

export default injectIntl(DeleteAslInductTestPackageModal);



// WEBPACK FOOTER //
// ./src/components/devicemanagement/asldevice/modal/DeleteAslInductTestPackageModal.js